export enum PopUpPosition {
  Center = 1,
  Top,
  Left,
  Right,
  Bottom,
  Positioned,
}
